import { Badge } from '@hkdevs/design-system';
import type { UploadSummary } from '../../api/queries/uploads';

/**
 * Uploads imported from Solar Payments (ADR 0027): their rows were copied, and the file
 * offered for download was rebuilt from them, not the spreadsheet that was uploaded.
 */

export const isLegacy = (upload: Pick<UploadSummary, 'source'>) => upload.source === 'legacy';

/** "Legacy import", beside the status of an imported upload. */
export const LegacyBadge = () => (
  <Badge variant="outline" size="sm">
    Legacy import
  </Badge>
);

export const downloadLabel = (upload: Pick<UploadSummary, 'source' | 'fileName'>) =>
  isLegacy(upload)
    ? `Download ${upload.fileName} (reconstructed from the imported rows)`
    : `Download ${upload.fileName}`;
